export class Place {
    id:number;
    description:string;

    
     constructor(data:any) {
         Object.assign(this, data);
     }
}
 